/**
 * 销账时使用VO
 */
export class WriteOffModel {
  constructor(data) {
    this._data = data || {}
  }

  get ourBank() {
    return this._data.ourBank
  }
  set ourBank(ourBank) {
    this._data.ourBank = ourBank || ''
  }

  get ourBankAccount() {
    return this._data.ourBankAccount
  }
  set ourBankAccount(ourBankAccount) {
    this._data.ourBankAccount = ourBankAccount || ''
  }

  get ourBankAccountId() {
    return this._data.ourBankAccountId
  }
  set ourBankAccountId(ourBankAccountId) {
    this._data.ourBankAccountId = ourBankAccountId || 0
  }

  get writeoffCurrency() {
    return this._data.writeoffCurrency
  }
  set writeoffCurrency(writeoffCurrency) {
    this._data.writeoffCurrency = writeoffCurrency || ''
  }

  get receiveType() {
    return this._data.receiveType
  }
  set receiveType(receiveType) {
    this._data.receiveType = receiveType || ''
  }

  get cashTransferState() {
    return this._data.cashTransferState
  }
  set cashTransferState(cashTransferState) {
    this._data.cashTransferState = cashTransferState || 0
  }

  get account() {
    return this._data.account
  }
  set account(account) {
    this._data.account = account || ''
  }

  get payCompany() {
    return this._data.payCompany
  }
  set payCompany(payCompany) {
    this._data.payCompany = payCompany || ''
  }

  get payBank() {
    return this._data.payBank
  }
  set payBank(payBank) {
    this._data.payBank = payBank || ''
  }

  get payAccountNo() {
    return this._data.payAccountNo
  }
  set payAccountNo(payAccountNo) {
    this._data.payAccountNo = payAccountNo || ''
  }

  get voucherNo() {
    return this._data.voucherNo
  }
  set voucherNo(voucherNo) {
    this._data.voucherNo = voucherNo || ''
  }

  getData() {
    return this._data
  }
  /**
   * 获取所有属性名称
   */
  getPropertyNames() {
    const obj = new WriteOffModel(this._data)
    let names = Object.getOwnPropertyNames(Reflect.getPrototypeOf(obj))
    names = names.filter(p => typeof obj[p] !== 'function')
    return [...names]
  }
  /**
   * 填充默认值
   */
  fillDefaultValue() {
    for (const name of this.getPropertyNames()) {
      if (typeof this[name] === 'undefined') {
        this[name] = ''
      }
    }
    return this
  }
}
